// How wide the assistant drawer opens, and how far a drag may take it. Both live here rather than
// inline in AssistantDrawer so the numbers have one home and the clamp can be tested without
// simulating a pointer.

/** Opening width in px, before any drag. Every opening gets it unless it asks for more room. */
export const DEFAULT_ASSISTANT_WIDTH = 384;

/**
 * The width the Grow improve answer opens at, twice the default (@adr SPARK-0019-assistant-lives-on-the-right-edge@2).
 * That answer is a structured document (definition, self-assessment, three worked examples) and at
 * 384 nearly every line wrapped, so reading it meant a lot of scrolling. Only that entry point asks
 * for it; every other opening keeps the default. The viewport cap below still applies, so a 1280px
 * laptop shows 640 and the page keeps its half.
 */
export const WIDE_ASSISTANT_WIDTH = 768;

/** Narrower than this and the thread list gets cramped. */
export const MIN_ASSISTANT_WIDTH = 280;

/** The drawer never takes more than half the window, so the page is always still usable. */
export function maxAssistantWidth(viewportWidth: number): number {
  return Math.floor(viewportWidth / 2);
}

/**
 * What the drawer shows: the person's own width (the default until they drag), or the wide one while
 * an answer that asked for it has the drawer, whichever is larger. Someone who already dragged it
 * wider keeps their width.
 */
export function shownAssistantWidth(width: number, wide: boolean): number {
  return wide ? Math.max(width, WIDE_ASSISTANT_WIDTH) : width;
}

export function clampAssistantWidth(next: number, viewportWidth: number): number {
  return Math.min(maxAssistantWidth(viewportWidth), Math.max(MIN_ASSISTANT_WIDTH, next));
}
